module.exports = __webpack_public_path__ + "static/media/counter-comment-icon.d5bcd382.svg";